import lock from "../../../../images/lock.svg";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export function ThreadRecording(props) {
    const { isLoadingRecording, callRecordingUrl, selectedItem, handleGetRecordings} = props;

   if (isLoadingRecording) {
    return (
      <div className="p-8 mx-auto rounded-lg border flex gap-x-4 items-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
        <p className="text-md font-medium text-black">Downloading audio...</p>
      </div>
    );
  }

   if (callRecordingUrl !== "") {
    return (
      <div className="p-4 mx-auto rounded-lg border w-full space-y-4">
        <div className="text-md font-medium text-gray-700">Call Recording</div>
        <audio
          controls
          className="w-full"
        >
          <source
            src={callRecordingUrl}
            type="audio/wav"
          />
          Your browser does not support the audio element.
        </audio>
      </div>
    );
  }

  if (
    selectedItem.sourceOfConversation === "INBOUNDVOICE" ||
    selectedItem.sourceOfConversation === "OUTBOUNDVOICE"
  ) {
    return (
      <div
        onClick={handleGetRecordings}
        className="p-6 mx-auto border rounded-lg flex items-center cursor-pointer"
      >
        <div className="flex flex-row items-center">
          <img
            style={{ width: "30px" }}
            className="m-2"
            src={lock}
            alt="Lock Icon"
          />
          <span className="bg-white pr-2 text-sm text-gray-500">
            Download call recording securely
          </span>
        </div>
      </div>
    );
  }

  return null;
}
